
export default [

  {
    path: '/investment',
    meta: {
      title: '招商引资'
    },
    redirect: '/investment/index',
    component: () =>
      import(
        /* investment: "index" */ '../../pages/investment/index.vue'
      ),
      children: [
        {
          path: '/investment/index',
          meta: {
            title: '招商引资'
          },
          component: () =>
            import(
              /* investment: "index" */ '../../pages/investment/views/index.vue'
            )
        },
        {
          path: '/investment/message',
          meta: {
            title: '留言管理'
          },
          component: () =>
            import(
              /* investment: "message" */ '../../pages/investment/views/message.vue'
            )
        },
        {
          path: '/investment/messageDetails',
          meta: {
            title: '留言详情'
          },
          component: () =>
            import(
              /* investment: "messageDetails" */ '../../pages/investment/views/messageDetails.vue'
            )
        },
        {
          path: '/investment/messageHandle',
          meta: {
            title: '留言处理'
          },
          component: () =>
            import(
              /* investment: "messageHandle" */ '../../pages/investment/views/messageHandle.vue'
            )
        },
        {
          path: '/investment/activity',
          meta: {
            title: '招商活动列表'
          },
          component: () =>
            import(
              /* investment: "activity" */ '../../pages/investment/views/activity.vue'
            )
        },
        {
          path: '/investment/activityDetails',
          meta: {
            title: '招商活动详情'
          },
          component: () =>
            import(
              /* investment: "activityDetails" */ '../../pages/investment/views/activityDetails.vue'
            )
        },
        {
          path: '/investment/investor',
          meta: {
            title: '投资方列表'
          },
          component: () =>
            import(
              /* investment: "investor" */ '../../pages/investment/views/investor.vue'
            )
        },
        {
          path: '/investment/investorParticulars',
          meta: {
            title: '投资方详情'
          },
          component: () =>
            import(
              /* investment: "investorParticulars" */ '../../pages/investment/views/investorParticulars.vue'
            )
        },
        
        {
          path: '/investment/information',
          meta: {
            title: '信息发布列表'
          },
          component: () =>
            import(
              /* investment: "information" */ '../../pages/investment/views/information.vue'
            )
        },
        {
          path: '/investment/inforDetails',
          meta: {
            title: '信息详情'
          },
          component: () =>
            import(
              /* investment: "inforDetails" */ '../../pages/investment/views/infoDetails.vue'
            )
        },
        {
          path: '/investment/rejectReason',
          meta: {
            title: '驳回原因'
          },
          component: () =>
            import(
              /* investment: "rejectReason" */ '../../pages/investment/components/Information/rejectReason.vue'
            )
        },
        {
          path: '/investment/pendingReview',
          meta: {
            title: '项目管理列表'
          },
          component: () =>
            import(
              /* investment: "pendingReview" */ '../../pages/investment/views/pendingReview.vue'
            )
        },
        {
          path: '/investment/projectDetails',
          meta: {
            title: '项目详情'
          },
          component: () =>
            import(
              /* investment: "projectDetails" */ '../../pages/investment/views/projectDetails.vue'
            )
        },
        {
          path: '/investment/projectHandle',
          meta: {
            title: '驳回原因'
          },
          component: () =>
            import(
              /* investment: "projectHandle" */ '../../pages/investment/views/projectHandle.vue'
            )
        },
        {
          path: '/investment/investorParticularsDetails',
          meta: {
            title: '对接洽谈详情'
          },
          component: () =>
            import(
              /* investment: "investorParticularsDetails" */ '../../pages/investment/views/investorParticularsDetails.vue'
            )
        }
      ]
      
  },

];
